module.exports = __webpack_public_path__ + "img/53.counter_handycap.9b4df8c6.svg";